/**
 * Nutrient Normalization - Backend API Adapter
 * 
 * This file replaces the old local normalization logic.
 * All normalization now happens on the backend!
 */

import { TestResult } from '../types'

/**
 * Check if data is already normalized (from backend)
 */
export function isNormalized(result: any): boolean {
  return result.normalized === true || result.per_100_cal === true
}

/**
 * Data from backend is already normalized - no calculation needed!
 */
export function normalizeNutrientValue(
  concentration: number | null,
  productName: string,
  analyte: string,
  allResults: TestResult[]
): number | null {
  // Backend already normalized the data
  return concentration
}

/**
 * Get suffix for normalized values
 */
export function getNormalizedSuffix(_analyte: string): string {
  return ''
}

/**
 * Check if analyte should be normalized
 */
export function shouldNormalizeAnalyte(analyte: string): boolean {
  const normalizedAnalytes = [
    'Protein',
    'Fat',
    'Carb',
    'Linoleic Acid',
    'Potassium',
    'Iron',
    'Calcium',
    'Sodium'
  ]
  return normalizedAnalytes.includes(analyte)
}
